import React from "react";

const Wrapper = ({ children, classname }) => {
  return (
    <>
      <div className={classname}>
        <div className="w-containerWidth max-w-full mx-auto lg:px-2 ">
          <div className="flex max-w-full">
            <div className="lg:w-72 xl:w-[374px] lg:mr-4 flex-shrink-0"></div>
            <div className="w-[calc(100%-396px)] flex-auto">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Wrapper;
